import { render, staticRenderFns } from "./LeaveEdit.vue?vue&type=template&id=6060b4c6"
import script from "../../controllers/teacher_leave/leave-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_leave/leave-edit.js?vue&type=script&lang=js&external"
import style0 from "./LeaveEdit.vue?vue&type=style&index=0&id=6060b4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports